
<style scoped>
/* Estilos para el botón de añadir más archivos */
.add-file-input-button {
  padding: 8px 15px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 15px;
  margin-bottom: 20px;
}

.add-file-input-button:hover {
  background-color: #218838;
}

/* Mantén otros estilos de tu formulario principal aquí */
</style>
<template>
  	<div>
    	<app-overlay-loader v-if="preloader" />
		<form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">      
			<div v-if="existingFiles.length > 0 || filesToDelete.length > 0">
				<h4>Existing Files</h4>
				<div v-for="fileData in existingFiles" :key="fileData.name">
					<FileInput
						v-if="!filesToDelete.includes(fileData.name)"
						label-text=""
						:initial-file="fileData"
						:file-data="fileData" :accepted-types="acceptedTypes"
						@file-cleared="handleExistingFileCleared"
						@remove-input="handleExistingFileRemoved"
						@file-selected="handleNewFileReplacedExisting"
						:is_edit="true"
					/>
				</div>
				<div v-if="filesToDelete.length > 0" class="mt-3">
					<p class="text-danger">Files marked for deletion: {{ filesToDelete.join(', ') }}</p>
				</div>
			</div>

			<h4>New files</h4>
			<div v-for="(input, index) in newFileInputs" :key="input.id">
				<FileInput
					:label-text="input.labelText"
					:accepted-types="acceptedTypes"
					@file-selected="fileData => handleNewFileInputSelected(fileData, index)"
					@file-cleared="() => handleNewFileInputCleared(index)"
					@remove-input="() => removeNewFileInput(index)"
				/>
			</div>

			<button type="button" @click="addNewFileInput" class="add-file-input-button">
				+ Add another file 
			</button>

			<div class="row">
				<div class="col-md-6">
					<button type="button" class="btn btn-primary mr-2 w-100" 
						@click="redirectToRevision">
						{{ $t('save_next') }}
					</button>
				</div>
			</div>
			<Modal
					v-if="showModal"
					@close="showModal = false"
					@downloadPO="downloadPO"
					@downloadSO="downloadSO"
					@goToContracts="goToContracts"
				/>
		</form>
  	</div>
</template>

<script>
import FileInput from './../components/imports/FileInput.vue';
import Modal from "./Modal.vue";

export default {
  	name: 'ImportDocuments',
  	components: { 
    	FileInput,Modal
  	},
  	data() {
    	return {
      		preloader: false,
      		contractNumber: null,
      		acceptedTypes: '*', 
      		existingFiles: [], 
      		newFileInputs: [], 
      		filesToDelete: [], 
      		nextNewInputId: 1, 
			showModal: false,
    	};
  	},
  	created() {
		const contract = JSON.parse(localStorage.getItem('DataContractMaster'));
		this.contractNumber = contract?.contractNumber;
		if (this.contractNumber) {
			this.fetchExistingFiles();
		}

		if (this.newFileInputs.length === 0 && this.existingFiles.length === 0) {
			this.addNewFileInput();
		}
  	},
  	methods: {
    async fetchExistingFiles() {
      	this.preloader = true;
      	try {
	        const response = await axios.get(`/api/contracts/${this.contractNumber}/files`);
        	this.existingFiles = response.data.files.map(fileName => ({ name: fileName }));
        	if (this.existingFiles.length === 0) { // <- si el contrato no tiene archivo agrega un input vacío
            	this.addNewFileInput();
        	}
      	} catch (error) {
        	console.error("Error fetching the list of existing files:", error);
      	} finally {
        	this.preloader = false;
      	}
    },

    addNewFileInput() {
      	this.newFileInputs.push({
        	id: this.nextNewInputId++,
        	labelText: `Select Additional File ${this.newFileInputs.length + 1}`,
        	file: null,
        	replaces: null 
      	});
    },

    handleNewFileInputSelected(data, index) {
      	this.newFileInputs[index].file = data.file;
    },

    handleNewFileInputCleared(index) {
      	this.newFileInputs[index].file = null;
    },

    removeNewFileInput(index) {
      this.newFileInputs.splice(index, 1);
    },

    handleExistingFileCleared(fileData) {
        if (fileData && fileData.name && !this.filesToDelete.includes(fileData.name)) {
            this.filesToDelete.push(fileData.name);
            console.log("Marked for deletion:", fileData.name);
        }
    },
    
    handleExistingFileRemoved(fileData) {
        this.handleExistingFileCleared(fileData);
    },


    handleNewFileReplacedExisting(data) {
        const { file, originalData } = data;
        if (originalData && originalData.name && !this.filesToDelete.includes(originalData.name)) {
            this.filesToDelete.push(originalData.name);
            console.log("Original marked for replace/delete:", originalData.name);
        }
        this.newFileInputs.push({
            id: this.nextNewInputId++,
            labelText: `Reemplazo de ${originalData.name}`, 
            file: file,
            replaces: originalData.name 
        });
        this.existingFiles = this.existingFiles.filter(f => f.name !== originalData.name);
    },

    async submitForm() {
      this.preloader = true;
      try {
        const formData = new FormData();
        formData.append("contractNumber", this.contractNumber); 

        this.newFileInputs.forEach((input, index) => {
          	if (input.file) {
            	formData.append(`uploadedFile_${index}`, input.file);
				if (input.replaces) {
					formData.append(`replacesFile_${index}`, input.replaces);
				}
          	}
        });

        if (this.filesToDelete.length > 0) {
          	formData.append('filesToDelete', JSON.stringify(this.filesToDelete));
        }

        const url = `/api/contracts/${this.contractNumber}/update-files`; 
        const response = await axios.post(url, formData);

        console.log("Operation completed:", response.data);
        this.fetchExistingFiles(); // Vuelve a cargar la lista de archivos para refrescar
        this.filesToDelete = []; // Limpia la lista de eliminados
        this.newFileInputs = []; // Limpia los nuevos inputs
        this.addNewFileInput(); // Y agrega uno vacío para nuevas subidas
      	} catch (error) {
        	console.error("Error in contract operation:", error);
      	} finally {
        	this.preloader = false;
      	}
    },

	async redirectToRevision() {
		let action = 'redirect';
		if (localStorage.getItem('process_add_contract')) {
			action = 'save';
		}
		if (action === 'redirect') {
			await this.submitForm();
			this.redirected = true;
			this.$router.push({
				name: 'revision',
				query: { 'tab': 'revision' },
				params: { id: this.contractId }
			});
		}
		else if(action === 'save'){
			this.saveCompleteForm();
		}
    },

	async saveCompleteForm() {
		this.preloader = true;
		try {
			const formData = new FormData();
			const contractMaster = localStorage.getItem("DataContractMaster");
			const contractDetails = localStorage.getItem("DataContractDetail");
			const contractProducts = localStorage.getItem("selectedProducts");
			const contractSupplierDetail = localStorage.getItem("DataSupplierDetail");
			const contractCustomerDetail = localStorage.getItem("DataCustomerDetail");

			formData.append("contractMaster", contractMaster);
			formData.append("contractDetails", contractDetails);
			formData.append("contractProducts", contractProducts);
			formData.append("contractSupplierDetail", contractSupplierDetail);
			formData.append("contractCustomerDetail", contractCustomerDetail);

			this.newFileInputs.forEach((input, index) => {
				if (input.file) {
					formData.append(`uploadedFile_${index}`, input.file); 
				}
			});
			
			const response = await axios.post(
				"/api/contracts/create_contract",
				formData,
			); 

			this.$toastr.s(response.data.message);
			this.contractId = response.data.contractId;
			setTimeout(() => {
				localStorage.removeItem("DataContractDetail");
				localStorage.removeItem("DataContractMaster");
				localStorage.removeItem("DataProductDetail");
				localStorage.removeItem("DataSupplierDetail");
				localStorage.removeItem("DataCustomerDetail");
				localStorage.removeItem("categorySelected");
				localStorage.removeItem("contractNumber");
				localStorage.removeItem("countrySelected");
				localStorage.removeItem("selectedProducts");
				localStorage.removeItem("process_add_contract");
			this.showModal = true;
			}, 1000);
		} catch (error) {
			let msg = "Error saving data";
			if (error.response.data?.error) {
			msg = error.response.data.error;
			}
			console.log(msg, error);
			this.$toastr.e(msg);
		}
		this.preloader = false;
	},
	downloadPO() {
		const base_url = localStorage.getItem("base_url");
		window.open(
			`${base_url}/contracts/downloadPo/${this.contractId}`,
			"_blank"
		);
	},
	downloadSO() {
		const base_url = localStorage.getItem("base_url");
		window.open(
			`${base_url}/contracts/downloadSo/${this.contractId}`,
			"_blank"
		);
	},
	goToContracts() {
		const base_url = localStorage.getItem("base_url");
		window.location.href = `${base_url}/contracts/list`;
	},
  },

  	
};
</script>
